;(function module() {
  angular.module('app.ui.form.ctrls').controller('ReferralListingController', [
    '$log',
    '$location',
    '$scope',
    '$modal',
    '$window',
    'logger',
    'ReferralApi',
    '$sce',
    '$uibModal',
    'userService',
    'socket',
    '$rootScope',
    function controller(
      $log,
      $location,
      $scope,
      $modal,
      $window,
      logger,
      ReferralApi,
      $sce,
      $uibModal,
      userService,
      socket,
      $rootScope
    ) {
      let vm = this
      socket.on('REFERRAL_CREATE', async referralCode => {
        if (
          vm.referralList.some(
            referral => referral.referralCode === referralCode
          )
        ) {
          const {data: updatedReferral} = await ReferralApi.getReferralsListing(
            {
              referralCode,
            }
          )
          const formatReferral = setGridData(updatedReferral)

          const updatedReferralIndex = vm.referralList.findIndex(
            referral => referral.referralCode === referralCode
          )

          vm.referralList[updatedReferralIndex] = formatReferral[0]
          vm.gridOptions.api.updateRowData({
            update: formatReferral,
          })
        } else {
          const {data: newReferral} = await ReferralApi.getReferralsListing({
            referralCode,
          })

          const formatReferral = setGridData(newReferral)

          vm.referralList = [...vm.referralList, ...formatReferral]
          vm.gridOptions.api.updateRowData({
            addIndex: 0,
            add: formatReferral,
          })
        }

        $scope.$apply()
        updateGridGroupPipeline()
      })
      const dateFilterParameters = {
        suppressAndOrCondition: true,
        inRangeInclusive: true,
        comparator: function(filterLocalDateAtMidnight, cellValue) {
          const dateAsString = moment(cellValue).format('DD/MM/YYYY')
          const dateParts = dateAsString.split('/')
          const cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
          )

          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0
          }

          if (cellDate < filterLocalDateAtMidnight) {
            return -1
          }

          if (cellDate > filterLocalDateAtMidnight) {
            return 1
          }
        },
      }

      // eslint-disable-next-line unicorn/consistent-function-scoping
      function renderDateTimeColumn(parameters) {
        return parameters.value
          ? `<span>` +
              moment(parameters.value).format('DD-MMM-YYYY HH:mm') +
              `</span>`
          : ' '
      }

      const columnDefs = [
        {
          headerName: 'Referrer Details',
          children: [
            {
              headerName: 'User ID',
              field: 'id',
              columnGroupShow: undefined,
              filter: 'agTextColumnFilter',
              cellRenderer: 'agGroupCellRenderer',
              sort: 'desc',
            },
            {
              headerName: 'Full Name',
              field: 'fullName',
              columnGroupShow: undefined,
              onCellClicked: viewProfile,
              filter: 'agTextColumnFilter',
              cellRenderer: parameter => {
                if (!parameter.data.referralCode.startsWith('e'))
                  return parameter.value
                    ? `<span class="text-info pointer"/>${parameter.value}</span>`
                    : ``
                return parameter.value
              },
            },
            {
              headerName: 'Email',
              field: 'email',
              columnGroupShow: undefined,
              filter: 'agTextColumnFilter',
            },
            {
              headerName: 'Referral Code',
              field: 'referralCode',
              filter: 'agTextColumnFilter',
              columnGroupShow: undefined,
              onCellClicked: showReferralCodeModal,
            },
            {
              headerName: 'Referrer Type',
              field: 'userType',
              rowGroupIndex: 0,
            },
            {
              headerName: 'IP Address',
              field: 'ip_Address',
              filter: 'agTextColumnFilter',
            },
            {
              headerName: '#Logins',
              field: 'loginCount',
            },
            {
              headerName: 'Last Login',
              field: 'lastLogin',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'Signup Date',
              field: 'created',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
          ],
        },
        {
          headerName: 'Referrals',
          children: [
            {
              headerName: 'Total Referred Candidates',
              field: 'totalReferredUsers',
              onCellClicked: parameters => {
                if (parameters.value)
                  parameters.api
                    .getDisplayedRowAtIndex(parameters.rowIndex)
                    .setExpanded(
                      !parameters.api.getDisplayedRowAtIndex(
                        parameters.rowIndex
                      ).expanded
                    )
              },
            },
            {
              headerName: 'Approved Referred Candidates',
              field: 'totalApprovedUsers',
            },
            {
              headerName: 'Successful Referrals',
              field: 'totalHiredUsers',
            },
            {
              headerName: 'Last Start Date',
              field: 'lastHiredUserDate',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
          ],
        },
      ]
      let masterDetailColumnDef = {
        detailGridOptions: {
          defaultColDef: {
            sortable: true,
            filter: true,
            enablePivot: true,
            enableRowGroup: true,
            enableValue: true,
            resizable: true,
            menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
          },
          columnDefs: [
            {
              headerName: 'Candidate ID',
              field: 'id',
            },
            {
              headerName: 'Candidate Name',
              field: 'fullName',
              onCellClicked: viewProfile,
              filter: 'agTextColumnFilter',
              cellRenderer: function(parameters) {
                return parameters.value
                  ? `<span class="text-info pointer"/>${parameters.value}</span>`
                  : ``
              },
            },
            {
              headerName: 'Candidate Status',
              field: 'approvalStatus',
            },
            {
              headerName: 'Hired',
              field: 'hiredStatus',
            },
            {
              headerName: 'Last Start Date',
              field: 'hiredDate',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
          ],
          onFirstDataRendered: function(parameters) {
            parameters.columnApi.autoSizeColumns()
          },
        },
        getDetailRowData: function(parameters) {
          ReferralApi.getAllReferralsByReferralCode(
            parameters.data.referralCode.toString()
          ).then(response => {
            response.data.forEach((row, index) => {
              response.data[index].fullName = row.firstName.concat(
                ' ',
                row.lastName
              )
              response.data[index].hiredStatus = row.hiredDate ? 1 : 0
            })

            parameters.successCallback(response.data)
          })
        },
      }

      const gridOptions = {
        defaultColDef: {
          sortable: true,
          filter: true,
          enablePivot: true,
          enableRowGroup: true,

          enableValue: true,
          columnGroupShow: 'open',
          resizable: true,
          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        },
        masterDetail: true,
        isRowMaster: dataItem => {
          return Boolean(dataItem.totalReferredUsers)
        },
        detailRowHeight: 250,
        detailCellRendererParams: masterDetailColumnDef,
        onFilterChanged: onFilterChanged,
        onModelUpdated: updateGridGroupPipeline,
        onGridReady: function() {
          getReferralsListing()
        },
        floatingFilter: true,
        suppressCsvExport: true,
        groupDefaultExpanded: 1,
        groupUseEntireRow: true,
        columnDefs: columnDefs,
        animateRows: true,
        getRowNodeId: function(data) {
          return data.referralCode
        },
        enableCellChangeFlash: true,
        groupSelectsChildren: true,
        rowData: vm.referralList,
        rowSelection: 'multiple',
        rowGroupPanelShow: 'always',
        pivotPanelShow: 'always',
        groupSelectsFiltered: true,

        sideBar: {
          toolPanels: ['columns', 'filters'],
          defaultToolPanel: false,
        },
        statusBar: {
          statusPanels: [
            {statusPanel: 'agTotalRowCountComponent', align: 'left'},
            {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
            {statusPanel: 'agSelectedRowCountComponent'},
            {statusPanel: 'agAggregationComponent'},
          ],
        },
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
        suppressCopyRowsToClipboard: true,
        enableRangeSelection: true,
        enableCharts: true,
        getContextMenuItems,
      }

      vm.gridOptions = gridOptions
      vm.gridName = 'referral'

      const getReferralsListing = async () => {
        vm.user = await userService.getUser()
        const referralList = await ReferralApi.getReferralsListing()

        if (referralList.status === 200) {
          vm.referralList = setGridData(referralList.data)

          vm.gridOptions = gridOptions
          vm.gridOptions.api.setRowData(vm.referralList)
          if (defaultFilter) vm.gridOptions.api.setFilterModel(defaultFilter)
          $rootScope.$broadcast('listing-loaded')
        }
      }

      var modalInstance
      let defaultFilter

      vm.profileLink = referralCode => {
        modalInstance.close()
        $window.open('/admin/lawyer-profile?user=' + referralCode, '_blank')
      }

      function onFilterChanged() {
        vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length
        // eslint-disable-next-line angular/document-service
        let filterTextBoxValue = document.querySelector('#filter-text-box')
          .value
        if (filterTextBoxValue.length > 0) {
          vm.filterCount += 1
        }

        updatePipelineCountFromGrid()
      }

      // TODO: on grid functionality
      function updatePipelineCountFromGrid() {
        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            vm.groupList.map(row => {
              if (row.id === node.id) {
                row.applicationsCount = node.allChildrenCount
                return row
              }

              return row
            })
          }
        })
        $scope.$applyAsync()
      }

      // TODO: on grid action items functionality
      function updateGridGroupPipeline() {
        vm.groupList = []

        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            let hasChild = true
            if (
              _.isEmpty(node.childrenMapped) ||
              'undefined' in node.childrenMapped
            )
              hasChild = false
            vm.groupList.push({
              name: node.key,
              applicationsCount: node.allChildrenCount,
              color: node.leafGroup
                ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                : lighten('#5e5e5e', (node.level + 1) * 10),
              id: node.id,
              intId: Number(node.id) * -1,
              level: node.level,
              parentID: node.parent.id,
              hasChild: hasChild,
              isHidden: node.level !== 0,
            })
          }
        })
        $log.debug('vm.groupList', vm.groupList)
        $scope.$applyAsync()
      }

      function showReferralCodeModal(parameters) {
        vm.referralCodeToShow = `${process.env.PUBLIC_URL}/sign-up/${parameters.value}`
        modalInstance = $modal.open({
          templateUrl: 'referral-link-modal.html',
          controller: function(referralCodeToShow) {
            let vm = this
            vm.referralCodeToShow = referralCodeToShow
            vm.copySuccess = () => {
              logger.notify('success', `Referral link copied to clipboard.`)
            }

            vm.copyFail = error => {
              logger.notify('error', error)
            }
          },
          controllerAs: 'ctrl',
          resolve: {
            referralCodeToShow: function() {
              return vm.referralCodeToShow
            },
          },
        })
        modalInstance.result.then(
          () => {},
          () => {}
        )
      }

      function getContextMenuItems(parameters) {
        var result = [
          {
            name: 'Open profile in new tab ',
            action: function() {
              if (!parameters.node.data.referralCode.startsWith('e')) {
                if (parameters.node.data.lawyer_Status === 'NewUser') {
                  $window.open(
                    '/profile?user=' + parameters.node.data.referralCode,
                    '_blank'
                  )
                } else
                  $window.open(
                    '/admin/lawyer-profile?user=' +
                      parameters.node.data.referralCode,
                    '_blank'
                  )
              }
            },
          },
          'separator',
          {
            name: 'Expand All Columns',
            action: function() {
              var columnApi = gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                gridOptions.columnApi.setColumnGroupOpened(item.groupId, true)
              })
            },
          },
          {
            name: 'Collapse All Columns',
            action: function() {
              var columnApi = gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                gridOptions.columnApi.setColumnGroupOpened(item.groupId, false)
              })
            },
          },
          'separator',
          'copy',
          'copyWithHeaders',
          'separator',
          'chartRange',
        ]
        vm.isExportAllowed = vm.user.roles.some(
          role => role.id === 'admin' || role.id === 'ops'
        )
        if (vm.isExportAllowed) result.push('export')
        return result
      }

      function viewProfile(parameters) {
        if (parameters.data.userType !== 'Non-member') {
          if (parameters.node.data.approvalStatus === 'New User') {
            $window.open(
              '/profile?user=' + parameters.node.data.referralCode,
              '_blank'
            )
          } else if (parameters.node.data.approvalStatus === 'Approved') {
            if (parameters.data.referralCode)
              vm.candidateProfile(parameters.data.referralCode)
            else vm.candidateProfile(parameters.data.id)
          }
        }
      }

      vm.candidateProfile = code => {
        modalInstance = $uibModal.open({
          templateUrl: 'candidateProfileModal.html',
          windowClass: 'app-candidate-profile-modal-window',
          controller: 'CandidateProfileModalController',
          resolve: {
            data: function() {
              return code
            },
          },
        })
      }

      if ($location.search().filterName && $location.search().filterValue) {
        let columnList = []
        columnDefs.forEach(row => {
          if (row.children) columnList.push(row.children)
        })
        let filterName = $location.search().filterName
        columnList = columnList.flat(Infinity)
        let column = columnList.find(row => row.field === filterName)
        if (column.field) {
          defaultFilter = JSON.parse(
            column.filter === 'agTextColumnFilter'
              ? `{"${filterName}":{"filterType":"text","type":"contains","filter":"${
                  $location.search().filterValue
                }"}}`
              : `{"${filterName}":{"values":["${
                  $location.search().filterValue
                }"],"filterType":"set"}}`
          )
        }
      }

      vm.helpTooltip = {
        name: 'Help',
        content: $sce.trustAsHtml(referrerHelpContent),
      }
    },
  ])
})()

const setGridData = allReferrersRecord => {
  return allReferrersRecord
    .map(data => {
      data.fullName = data.firstName.concat(' ', data.lastName)
      data.totalReferredUsers = Number(data.totalReferredUsers)
      data.totalApprovedUsers = Number(data.totalApprovedUsers)
      data.totalHiredUsers = Number(data.hiredApprovedUsers.totalHiredUsers)
      data.lastHiredUserDate = data.hiredApprovedUsers.lastHiredUserDate
      data.userType = data.referralCode.startsWith('e')
        ? 'Non-member'
        : 'Member'
      return data
    })
    .sort((a, b) => (a.userType > b.userType ? 1 : -1))
}

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}

const referrerHelpContent = `
<div>
<p>Referrals shows referrer details of (1) non-members who have signed up for a unique referral link; and (2) LexStep members who have made one or more referrals. Click the arrow on the left of a referror’s User ID to see details of whom they have referred.
</p>
<p>A “Referral” is when a LexStep member uses a referral code to sign up.
</p>
<p>A “Successful Referral” is when a referred LexStep member is hired.
</p>
<b>Filtering</b>
<p>Filters can be applied by hovering over each column header and selecting the hamburger menu on the right. When a filter is applied to a column a purple filter icon appears in the header beside the column name.
</p>
<p>Filters can be applied both to the columns showing the master information as well as the columns showing detailed information when expanding a row.
</p>
<b>Views</b>
<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the “Views” icon in the top right -- either as a Private “Saved View” or Shared with other team members.
</p>
<b>Clear</b>
<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data. The Clear filter icon also displays the number of filters currently active on the grid.
</p>
<b>Group</b>
<p>Drag and drop columns to the grouping drop zone in the grid’s top row to group rows by a particular column. You can Expand/Collapse All Rows from the Views icon in the top right to view positions by groups.
</p>
<b>Sorting</b>
<p>You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.
</p>
</div> `



// WEBPACK FOOTER //
// ./scripts/admin-panel/referral-listing/referral-listing.ctrl.js